export default "__VITE_ASSET__Ipxr4ceE__"